import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DeviceService } from '../../../../services/device.service';
import { ButtonIconComponent } from '../../../../shared/components/button-icon/button-icon.component';
import { InputImage } from '../../../../shared/components/input-image/input-image';
import { InputTextarea } from '../../../../shared/components/input-textarea/input-textarea';
import { AlarmDto } from '../../../../types/dtos/alarm.dto';
import { AlarmStatus } from '../../../../types/enums/alarm.enum';

import { AlarmStatusUpdateDataInterface } from '../../../../types/interfaces/alarm.interfaces';
import { InputImageInterface, InputTextAreaInterface } from '../../../../types/interfaces/input.interface';
import {TranslateSafePipe} from '../../../../shared/pipes/translation.pipe';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'alarm-status-update-dialog',
  imports: [
    ReactiveFormsModule,
    InputTextarea,
    ButtonIconComponent,
    InputImage,
    TranslateSafePipe,
  ],
  templateUrl: './alarm-status-update-dialog.html',
  styleUrl: './alarm-status-update-dialog.css',
})
export class AlarmStatusUpdateDialog {
  @Input()
  public alarm: AlarmDto | null = null;

  @Input()
  public loading: boolean = false;

  @Output()
  public submitUpdate: EventEmitter<AlarmStatusUpdateDataInterface> =
    new EventEmitter<AlarmStatusUpdateDataInterface>();

  @Output()
  public closeClick: EventEmitter<void> = new EventEmitter<void>();

  public updateForm: FormGroup = new FormGroup({
    comment: new FormControl(''),
    imageFiles: new FormControl<File[]>([]),
  });

  public commentConfig: InputTextAreaInterface = {
    formGroup: this.updateForm,
    isTranslated: true,
    label: 'common.fields.comment',
    id: 'comment',
    iconLeft: 'comment',
    infoText: 'common.messages.info.optional-comment',
  };

  public imageConfig: InputImageInterface = {
    formGroup: this.updateForm,
    id: 'imageFiles',
    accept: 'image/*',
    type: 'file',
  };

  constructor(
    private readonly _deviceService: DeviceService,
    private readonly _translateService: TranslateService,
  ) {

  }

  public get actionLabel(): string {
    if (!this.alarm) return '';
    if (this.alarm.status === AlarmStatus.ACTIVE) {
      return this._translateService.instant('common.actions.confirm');
    }

    if (this.alarm.status === AlarmStatus.ACKNOWLEDGED) {
      return this._translateService.instant('common.action.solve');
    }

    return '';
  }

  public get actionText(): string {
    if (!this.alarm) return '';
    if (this.alarm.status === AlarmStatus.ACTIVE) {
      return this._translateService.instant('common.action.confirm-alarm');
    }

    if (this.alarm.status === AlarmStatus.ACKNOWLEDGED) {
      return this._translateService.instant('common.action.acknowledge');
    }

    return this._translateService.instant('common.action.change-alarm-status');
  }

  public getDeviceNumber(id: number): string {
    return this._deviceService.getDeviceNumber(id) ?? '-';
  }

  public onSubmit(): void {
    if (!this.alarm || this.loading) {
      return;
    }

    this.submitUpdate.emit({
      status: this.alarm.status,
      comment: this.updateForm.get('comment')?.value ?? '',
      imageFile: this.updateForm.get('imageFiles')?.value?.[0] ?? undefined,
    });
  }

  public onCloseClick(): void {
    this.closeClick.emit();
  }
}
